module.exports = __webpack_public_path__ + "static/media/gist-web-app.59119918.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Services/img/gist-web-app.png
// module id = 180
// module chunks = 0